<template>
  <div>
    加载中......
    <!-- [Loading]........................
    <br><span>code:{{ code }}</span>
    <br><span>state：{{ state }}</span>
    <br><span>url：{{ url }}</span>
    <br><span>token:{{ token }}</span>
    <br><span>info:{{ info }}</span> -->
  </div>
</template>

<script>
import { getUrlKey } from '@/utils/base'
import { Toast } from 'vant'
// const Base64 = require('js-base64').Base64
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      code: undefined,
      state: undefined,
      url: undefined,
      token: undefined,
      info: undefined,
      isFirst: false
    }
  },
  created() {
    Toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true
    })
    this.isFirst = true
    console.log('loginCallback created')
    this.code = getUrlKey('code')
    this.state = getUrlKey('state')
    this.url = getUrlKey('url')
    // alert('loginCallback url:' + this.url)
    this.system = getUrlKey('system')
    this.$store.dispatch('user/wechatLogin', {
      code: this.code,
      state: this.state,
      url: this.url,
      system: this.system
    })
  }
}
</script>

